import React, { useState } from 'react';
import { Modal } from 'antd';
import lodash from 'lodash';

const PackageImagePreview = ({ packageData, noneData = 'Không có dữ liệu' }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const imageUrl = lodash.get(packageData, 'metadata.image_url', '');

    return (
        <span className="info--value _value">
      {imageUrl ? (
          <>
              <img
                  src={imageUrl}
                  alt="thumbnail"
                  style={{
                      width: 100,
                      height: 'auto',
                      marginLeft: '10px',
                      cursor: 'pointer',
                      borderRadius: 4,
                      boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                  }}
                  onClick={() => setIsModalOpen(true)}
              />
              <Modal
                  visible={isModalOpen}
                  footer={null}
                  onCancel={() => setIsModalOpen(false)}
                  centered
              >
                  <img
                      src={imageUrl}
                      alt="full"
                      style={{ width: '100%', height: 'auto' }}
                  />
              </Modal>
          </>
      ) : (
          noneData
      )}
    </span>
    );
};

export default PackageImagePreview;
